import {Pipe, PipeTransform} from '@angular/core';
import {TemperatureUnit} from '../enums/temperature-unit.enum';
import {AirComponentType} from '../../afb-api/enums/air-component-type.enum';

@Pipe({
  name: 'tempConverter'
})

export class TemperatureConverterPipe implements PipeTransform {
  transform(rawValue: number, type: AirComponentType, unit: TemperatureUnit): number {
    if (type === AirComponentType.Temperature && !isNaN(rawValue)) {
      const tempUnit = {
        [TemperatureUnit.Celsius]: rawValue,
        [TemperatureUnit.Fahrenheit]: Number((this.celsiusToFahrenheit(rawValue)).toFixed(2))
      };
      return tempUnit[unit] != null ? tempUnit[unit] : null;
    } else if (type !== AirComponentType.Temperature) {
      return rawValue;
    }

    return null;
  }

  // Convert celsius temp to fahrenheit
  celsiusToFahrenheit(celsius: number): number {
    return celsius * 9 / 5 + 32;
  }
}
